import { render } from "./PollStudents.vue?vue&type=template&id=551a618b&scoped=true"
import script from "./PollStudents.vue?vue&type=script&lang=js"
export * from "./PollStudents.vue?vue&type=script&lang=js"

import "./PollStudents.vue?vue&type=style&index=0&id=551a618b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551a618b"]])

export default __exports__